import styled from 'styled-components';
import { Alert } from 'antd';

export const SubstitutionContainer = styled.div`
  .ant-typography {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const CancellationAlert = styled(Alert)`
  padding: 16px 24px !important;
  text-align: center;
  .ant-alert-message {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-typography {
    font-size: 1rem;
    strong {
      color: ${({ theme }) => theme.colors.primary} !important;
    }
  }

  .anticon-loading {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
